<template>
	<form class="content content-600 column flexible article" @submit="submitForm">
		<header class="row centering separated">
			<router-link class="rigid" to="/"><i class="fas fa-arrow-left"></i></router-link>
			<h1 class="rigid capitalize">{{pageHeader}}</h1>
		</header>

		<div class="column panel">
			<spinner v-if="userStatus.loading"></spinner>
			<div v-else-if="address">
				<div class="notice above">
					Need to change your address? Send us a <a class="rigid" href="mailto:support@support.tekcloud.com?subject=Change%20Address">note</a> and we'll update it for you.
				</div>
				<div class="billing-address card card-secondary">
					<h5 class="uppercase">Current Address</h5>
					<address class="column separated">
						<div class="name">{{address.firstName}} {{address.lastName}}</div>
						<div class="org">{{address.organization}}</div>
						<div class="street-address">{{address.addressLine1}}</div>
						<div v-if="address.line2" class="street-address">{{address.addressLine2}}</div>
						<div><span class="locality">{{address.city}}</span>, <span title="Oregon" class="region">{{address.state}}</span> <span class="postal-code">{{address.postalCode}}</span></div>
						<div class="country-name">{{address.country}}</div>
					</address>
				</div>
			</div>

			<address-form :is-submitting="submitting" @clear-error="createAddressError = null" :error="createAddressError" v-else @change="onAddressChange"></address-form>

			<footer v-if="address" class="row separated right centering">
				<router-link class="button rigid" to="/">Go Back</router-link>
			</footer>
			<footer v-else-if="userStatus.success" class="row separated right centering">
				<router-link class="button rigid" to="/">Cancel</router-link>
				<submit-button type="submit" class="primary rigid" :button-text="'Add Address'" :submitting-text="'Adding Address'" :is-submitting="submitting" :is-disabled="createAddressError || !newAddress || (newAddress && !newAddress.complete) || submitting"></submit-button>
			</footer>
		</div>

	</form>
</template>

<script>
import AddressForm from '../components/AddressForm';
import Spinner from '../components/Spinner';
import { mapGetters } from 'vuex';
import ENV_VARS from '@/modules/env-vars.js';
import SubmitButton from '../components/SubmitButton';




export default {
	name: 'Address',
	components:{
		AddressForm,
		SubmitButton,
		Spinner
	},
	data(){
		return {
			submitting: false,
			createAddressError :null,
			newAddress: null
		};
	},
	computed:{
		...mapGetters([
			'address',
			'userStatus'
		]),
		pageHeader(){
			return (this.address ? 'Change' : 'Add') + ' Address';
		},
	},
	methods:{
		onAddressChange(val){
			this.newAddress = val;
		},
		submitForm(e){
			e.preventDefault();
			let vm = this;
			vm.submitting = true;

			this.$store.dispatch('CREATE_ADDRESS_REQUEST', this.newAddress)
				.then(address => {
					this.$store.dispatch('SET_ADDRESSES', [this.newAddress]);
					this.$router.push('/');
					vm.submitting = false;
				})
				.catch(reason => {
					vm.createAddressError = reason;
					vm.submitting = false;
				});
		},
	}
};
</script>

<style scoped>
address {
	color: #555;
}
address > div {
	margin-bottom: 2px;
}
.panel {
	background: white;
	border-radius: 6px;
	padding: 2rem;
	border: 2px solid #dfdfdf;
	width: 100%;
	margin: auto;
	box-sizing: border-box;
}
.dark .panel {
	background: #1a1a1a;
	border: 2px solid #333;
}

.panel footer {
	margin-top: 2em;
}
</style>



// WEBPACK FOOTER //
// ./src/views/Address.vue